export const GIF_MEDIA_TYPE = "GIF";

export const MIN_GIF_IMAGES = 2;
export const MAX_GIF_IMAGES = 6;

export const ALLOWED_GIF_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
];

export const ALLOWED_GIF_ACCEPT = "image/png,image/jpeg,image/gif";

export const MAX_GIF_SOURCE_FILE_SIZE = 2.5 * 1024 * 1024;
export const MIN_SOURCE_DIMENSION = 64;
export const MAX_SOURCE_DIMENSION = 4096;

export const GIF_SETTING_LIMITS = {
  width: { min: 64, max: 1920 },
  height: { min: 64, max: 1080 },
  frameDelay: { min: 50, max: 5000 },
  loopCount: { min: 0, max: 100 },
  crossfadeSteps: { min: 2, max: 30 },
};

export const DEFAULT_GIF_SETTINGS = {
  width: 640,
  height: 360,
  frameDelay: 500,
  loopCount: 0,
  crossfade: false,
  crossfadeSteps: 5,
  background: "#ffffff",
};

export const createEmptyGifState = (overrides = {}) => {
  const cleaned = Object.fromEntries(
    Object.entries(overrides || {}).filter(([, value]) => value !== undefined)
  );

  return {
    images: [],
    ...DEFAULT_GIF_SETTINGS,
    previewUrl: "",
    fileName: "",
    mimeType: "image/gif",
    fileSize: 0,
    mediaProperty: null,
    generatedSignature: "",
    isEditing: true,
    isUnsaved: false,
    generating: false,
    generatedFile: null,
    ...cleaned,
  };
};

export const createGifImageId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
